import { Grid } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import { getSubLabel } from 'lib/util/string'
import ApplicationContext from 'platform/react/context/application'
import { useContext } from 'react'
import Text from 'ui/Element/Text'

const styles = theme => ({
  row: {
    gap: 12,
    flexWrap: 'nowrap',
  },
  subLabel: {
    gap: 4,
    flexWrap: 'nowrap',
  },
})

/**
 * Displays information about an organisation.
 *
 * @param {Object} classes  element's style classes
 * @param {Object} props    element's properties
 *
 * @returns {JSX.Element}
 */
export const ListItemCellOrganisationInformation = (classes, props = {}) => {
  const { intl } = useContext(ApplicationContext)

  const {
    name,
    number,
    address,
  } = props

  const subLabel = getSubLabel(Text, [number, `${intl.address(address, { inline: true })}`], '•', { component: 'div' })

  return (
    <Grid
      container
      direction={'row'}
      className={classes.row}
    >
      <Grid container>
        <Grid
          container
          gap={'0.125rem'}
          direction={'column'}
          alignItems={'flex-start'}
          justifyContent={'center'}

          sx={{ height: '100%' }}
        >
          <Text
            maxLines={1}
            value={name}
            variant={'14/bold'}
            color={'black.main'}
          />
          {(number || address) && (
            <Grid
              item
              container
              xs={'auto'}
              className={classes.subLabel}
            >
              {subLabel}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CellHOC(ListItemCellOrganisationInformation, styles)
